export default __webpack_public_path__ + "static/media/no-data-icon.e6bce042.svg";